(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    class ProductTabsComponent extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('.product-tabs__panel'));
      this.buttons = Array.from(this.querySelectorAll('[data-tab-button]'));

      this.splitDescriptionIntoCharacteristics();

      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.activate(index));
      });

      this.activate(0);
    }

    activate(index) {
      this.buttons.forEach((button, i) => {
        button.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
    }

    splitDescriptionIntoCharacteristics() {
      const descriptionPanel = this.panels[0];
      const characteristicsPanel = this.panels[1];
      if (!descriptionPanel || !characteristicsPanel || characteristicsPanel.dataset.split) return;
      characteristicsPanel.dataset.split = 'true';

      const heading = Array.from(descriptionPanel.querySelectorAll('h2')).find((h) =>
        h.textContent.trim().toLowerCase().startsWith('caractéristiques')
      );
      if (!heading) return;

      const toMove = [heading];
      let sibling = heading.nextElementSibling;
      for (let i = 0; i < 2 && sibling; i += 1) {
        toMove.push(sibling);
        sibling = sibling.nextElementSibling;
      }
      toMove.forEach((node) => characteristicsPanel.appendChild(node));

      while (sibling) {
        const next = sibling.nextElementSibling;
        sibling.remove();
        sibling = next;
      }
    }
  }

  customElements.define('product-tabs-component', ProductTabsComponent);
  } catch(e) { console.error(e); }
})();

})();
